import { Component, computed, inject, input, output } from '@angular/core';
import type { ModalAction } from '@purolator/ui-kit-angular';
import { ModalComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe, TranslationService } from '../../../../core/i18n';

/**
 * Shared single-action payment notice dialog for deny (OM-643/OM-638) and timeout (OM-640).
 * Pass either a literal `message` or an i18n `bodyKey` for the body copy.
 */
@Component({
  selector: 'app-review-payment-notice-dialog',
  imports: [ModalComponent, TranslatePipe, TypographyComponent],
  templateUrl: './review-payment-notice-dialog.html',
  styleUrl: './review-payment-notice-dialog.scss',
})
export class ReviewPaymentNoticeDialog {
  private readonly translation = inject(TranslationService);

  readonly open = input(false);
  /** i18n key for the modal title. */
  readonly titleKey = input.required<string>();
  /** i18n key for the primary footer action label. */
  readonly actionLabelKey = input.required<string>();
  /** Literal body text (deny outcome copy). Wins over `bodyKey` when non-empty. */
  readonly message = input('');
  /** i18n key for the body when `message` is empty (timeout). */
  readonly bodyKey = input('');
  /** Optional test id for the body typography element. */
  readonly messageTestId = input<string | null>(null);
  readonly dismissed = output<void>();

  protected readonly modalTitle = computed(() => {
    this.translation.revision();
    return this.translation.translate(this.titleKey());
  });

  protected readonly actions = computed<ModalAction[]>(() => {
    this.translation.revision();
    return [
      {
        label: this.translation.translate(this.actionLabelKey()),
        variant: 'primary',
        onClick: () => this.onDismiss(),
      },
    ];
  });

  /**
   * Closes the notice dialog and keeps the customer on Review & Pay.
   */
  protected onDismiss(): void {
    this.dismissed.emit();
  }
}
